
import { computed, defineComponent, PropType, ref, watch } from "vue";
import { Slider } from "ant-design-vue";
import { displayType } from "@/types/SurveyInfo";

interface IMarks {
  [name: number]: number;
}
interface IAnswerSlider {
  sliderMinBorderDescRu: string;
  sliderMinBorderDescKk: string;
  sliderMaxBorderDescRu: string;
  sliderMaxBorderDescKk: string;
  sliderMinBorder: number;
  sliderMaxBorder: number;
}

export default defineComponent({
  name: "RateBlock",

  components: {
    ASlider: Slider,
  },

  props: {
    text: String,
    currentLang: String,
    index: Number,
    answerSlider: Object,
    status: Boolean,
    noMarks: Boolean,
    type: {
      type: String as PropType<displayType | undefined>,
      required: false,
    },
  },
  emits: ["answersFields", "next-question"],

  setup(props, { emit }) {
    const curLang = computed(() => props.currentLang);
    const wasChosen = ref<boolean>(false);

    const params = computed(() => {
      let data = props.answerSlider as IAnswerSlider,
        marks: IMarks = {};

      for (let i = data?.sliderMinBorder; i <= data.sliderMaxBorder; i++) {
        marks[i] = i;
      }

      const options = {
        borderMinText:
          (curLang.value === "RU"
            ? data.sliderMinBorderDescRu
            : data.sliderMinBorderDescKk) || "",
        borderMaxText:
          (curLang.value === "RU"
            ? data.sliderMaxBorderDescRu
            : data.sliderMaxBorderDescKk) || "",
        min: data.sliderMinBorder || 0,
        max: data.sliderMaxBorder || 10,
        marks: marks,
        color: "var(--brand-color, #1d8de1)",
      };
      return options;
    });
    const sliderValue = ref<number>(Math.ceil(params.value.max / 2) || 1);

    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    const playSound = () => {
      let audio = new Audio("/w/sound/treschotka.mp3");
      audio.play();
    };

    const activateVibration = () => {
      if ("vibrate" in navigator) {
        navigator.vibrate(200);
      } else {
        console.log("Вибрация не поддерживается на вашем устройстве");
      }
    };

    const sliderChange = () => {
      wasChosen.value = true;
    };

    const sliderAfterChange = () => {
      if (isMobile) {
        playSound();
        activateVibration();
      }
    };

    watch(
      () => sliderValue.value,
      (v: number) => {
        const correctValue =
          v > params.value.max
            ? params.value.max
            : v < params.value.min
            ? params.value.min
            : v;

        emit("answersFields", props.index, {
          sliderChoiseVal: correctValue,
        });
      }
    );

    return {
      curLang,
      sliderValue,
      wasChosen,
      sliderAfterChange,
      sliderChange,
      params,
    };
  },
});
